export default {
  FaixaSalarial: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "faixa-salarial"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/FaixaSalarial.js
// module id = EqI9
// module chunks = 13